import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("spark_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Build authenticated image URL using ?auth= query param (since <img> can't send headers).
// Full http(s) URLs (e.g. seeded demo Unsplash photos) are returned as-is.
// Pass `w` (pixel width) to get a fast, cached, compressed thumbnail.
export const fileUrl = (storagePath, w) => {
  if (!storagePath) return null;
  if (/^https?:\/\//i.test(storagePath)) return storagePath;
  const token = localStorage.getItem("spark_token");
  const base = `${API}/files/${storagePath}?auth=${encodeURIComponent(token || "")}`;
  return w ? `${base}&w=${w}` : base;
};
